<template>
  <div class="consult">
    <en-title v-if="title || enTitle" :title="title" :enTitle="enTitle"></en-title>
    <div class="container" v-if="typeList.indexOf('orderOnline') > -1">
      <p class="fb">
        使用擎科生物的
        <span
          style="color: #014492"
          class="pointer"
          @click="jumps(`/tec/order_${jumpsType}`)"
          >在线订购系统</span>
        ，可在线下单{{ type!=="sanger" ? ",便捷查询合成进度。" : "。" }}
      </p>
      <p class="mt10 fb">
        如在线订购系统不能满足您的下单需求，请下载
        <!-- <a :href="sameFile ? downloadFile : jumpFile">{{ type!=="sanger" ? "电子订单" : "测序样本登记单"}}</a> -->
        <el-button  v-if="type=='sanger'" type="text" @click="sangerDownloadFile">测序样本登记单</el-button> 
        <a v-else :href="sameFile ? downloadFile : jumpFile">{{ type!=="sanger" ? "电子订单" : "测序样本登记单"}}</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。
      </p>
    </div>
    <div class="container" v-if="typeList.indexOf('sampling') > -1">
      <p class="fb">
        {{ samplingText }}如果需要了解详细送样要求，<a :href="samplingFile[0]" target="_blank">请点此查看</a>。
      </p>
      <p class="mt10 fb">
        擎科生物可以提供北京、天津、上海、广州、深圳、武汉、成都等地区上门干冰取样服务，具体详情可以咨询当地销售，如无法上门取样，老师可以选择邮寄服务。寄样前请填写我们
        <a :href="samplingFile[1]">《组织样本送样信息单》</a>或<a :href="samplingFile[2]">《核酸样本送样信息单》</a>，具体信息请按表格填写，如有疑问，可以咨询当地销售。
      </p>
    </div>
    <div class="container" v-if="typeList.indexOf('serviceOnline') > -1">
      <p class="fb">
        点击<a :href="downloadFile">订单下载获取慢病毒包装订购表</a>，填写并发送至邮箱gt-service@tsingke.com.cn，即可咨询下单。
      </p>
    </div>
    <div class="container con">
      <ul class="order mt30" :class=" imgType === 'virus' && 'order1' ">
        <li v-if="typeList.indexOf('telePhone') > -1">
          <label><img src="@/assets/images/icon_tel.png" />电话 </label>
          <dl>
            <dd>
              <span>{{ phoneNumber }}</span>
            </dd>
          </dl>
        </li>
        <li v-if="typeList.indexOf('consult') > -1">
          <label><img src="@/assets/img/zx.png" />咨询</label>
          <dl class="phone">
            点击
            <router-link to="/summary/contact"
              ><span
                style="
                  color: #014492;
                  font-weight: bold;
                  margin-left: 5px;
                  margin-right: 5px;
                "
                >联系我们,</span
              ></router-link
            >获取全国实验室联系方式
          </dl>
        </li>
        <li v-if="typeList.indexOf('download') > -1">
          <label><img src="@/assets/images/icon_down.png" />下载</label>
          <dl>
            <dd>
              <el-button type="text" v-if="type === 'sanger'" @click="sangerDownloadFile"><span>订单下载</span></el-button> 
              <a v-else :href="downloadFile"><span>订单下载</span></a> 
              <a class="ml20" v-if="type === 'sanger'" href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/release/excel/%E5%AE%A2%E6%9C%8D%E6%9F%A5%E7%9C%8B-%E6%93%8E%E7%A7%91%E8%BD%BD%E4%BD%93%E9%80%9A%E7%94%A8%E5%BC%95%E7%89%A9%E8%A1%A8.xlsx" target="_blank"><span>通用引物表下载</span></a>
            </dd>
          </dl>
        </li>
        <li v-if="typeList.indexOf('email') > -1">
          <label><img src="@/assets/images/icon_email.png" />邮箱</label>
          <dl>
            <dd v-for="(item, index) of emailList[type]" :key="index">
              {{ item.title }}<span>{{ item.email }}@tsingke.com.cn</span>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import EnTitle from "./EnTitle";
import { sangerDownlodFile } from '@/services/api.index'
export default {
  components: { EnTitle },
  name: "new-consult",
  props: {
    title: {
      type: String,
      default: "订购与咨询",
    },
    enTitle: {
      type: String,
      default: "Ordering and Consulting",
    },
    // gene:基因合成（包含子页面）+ 产品及服务
    // primer:寡核苷酸合成+寡核苷酸-DNA合成
    // rna:RNA合成
    // merging:修饰合成
    // service:慢病毒包装
    type: {
      type: String, 
      default: "gene",
    },
    // gene-ssDNA : 基因合成-长单链，单独有下载文件
    downloadType: {
      type: String,
      default: ''
    },
    typeList: {
      type: Array,
    },
    // 样本制备与寄样前段文字
    samplingText: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: "400-668-3730",
    },
    // 判断两个下载是否是一个文件，不是的话暂时取一个默认值
    sameFile: {
      type: Boolean,
      default: true,
    },
    // 电话咨询等所需背景图，默认为蓝的，virus为灰的
    imgType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      emailList: {
        gene: [
          {
            title: "基因合成部：",
            email: "gene",
          },
        ],
        rna: [
          {
            title: "北京：",
            email: "RNAservice",
          },
        ],
        merging: [
          {
            title: "修饰合成部：",
            email: "oligo",
          },
        ],
        service: [
          {
            title: "",
            email: "gt-service",
          },
        ],
        primer: [
          {
            title: "北京：",
            email: "bj-synth",
          },
          {
            title: "青岛：",
            email: "qd-synth",
          },
          {
            title: "南京：",
            email: "nj-synth",
          },
          {
            title: "上海：",
            email: "sh-synth",
          },
          {
            title: "杭州：",
            email: "hz-synth",
          },
          {
            title: "广州：",
            email: "gz-synth",
          },
          {
            title: "长沙：",
            email: "cs-synth",
          },
          {
            title: "武汉：",
            email: "wh-synth",
          },
          {
            title: "西安：",
            email: "xa-synth",
          },
          {
            title: "郑州：",
            email: "zz-synth",
          },
          {
            title: "重庆：",
            email: "cq-synth",
          },
          {
            title: "成都：",
            email: "cd-synth",
          },
          {
            title: "昆明：",
            email: "km-synth",
          },
          {
            title: "厦门：",
            email: "xm-synth",
          },
          {
            title: "南宁：",
            email: "nn-synth",
          },
          {
            title: "海南：",
            email: "hk-synth",
          },
          {
            title: "苏州：",
            email: "sz-synth",
          },
          {
            title: "深圳：",
            email: "shenzhen-synth",
          },
          {
            title: "济南：",
            email: "jn-synth",
          },
        ],
        sanger: [
          {
            title: "北京：",
            email: "bj-seq",
          },
          {
            title: "青岛：",
            email: "qd-seq",
          },
          {
            title: "南京：",
            email: "nj-seq",
          },
          {
            title: "上海：",
            email: "sh-seq",
          },
          {
            title: "杭州：",
            email: "hz-seq",
          },
          {
            title: "广州：",
            email: "gz-seq",
          },
          {
            title: "长沙：",
            email: "cs-seq",
          },
          {
            title: "武汉：",
            email: "wh-seq",
          },
          {
            title: "西安：",
            email: "xa-seq",
          },
          {
            title: "郑州：",
            email: "zz-seq",
          },
          {
            title: "重庆：",
            email: "cq-seq",
          },
          {
            title: "成都：",
            email: "cd-seq",
          },
          {
            title: "昆明：",
            email: "km-seq",
          }
        ],
      },
      samplingFile: [
        "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E8%BD%AC%E5%BD%95%E7%BB%84%E9%99%84%E4%BB%B6/%E8%BD%AC%E5%BD%95%E7%BB%84%E6%B5%8B%E5%BA%8F%E9%80%81%E6%A0%B7%E8%A6%81%E6%B1%82.pdf", 
        "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E8%BD%AC%E5%BD%95%E7%BB%84%E9%99%84%E4%BB%B6/%E8%BD%AC%E5%BD%95%E7%BB%84%E7%BB%84%E7%BB%87%E6%A0%B7%E5%93%81%E4%BF%A1%E6%81%AF%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx", 
        "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E8%BD%AC%E5%BD%95%E7%BB%84%E9%99%84%E4%BB%B6/%E8%BD%AC%E5%BD%95%E7%BB%84RNA%E6%A0%B7%E5%93%81%E4%BF%A1%E6%81%AF%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx"
      ],
      ossList:{
        // 基因合成订购表
        gene: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx",
        // RNA订购表
        rna: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9RNA%E8%AE%A2%E8%B4%AD%E8%A1%A8_20220801.xlsx",
        // 修饰引物订购表
        merging: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91-%E6%A2%93%E7%86%99%E7%94%9F%E7%89%A9%E4%BF%AE%E9%A5%B0%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8_20220801.xlsx",
        // 引物合成订购表
        primer: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx",
        // 测序样本登记单
        sanger: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E6%B5%8B%E5%BA%8F%E6%A0%B7%E6%9C%AC%E7%99%BB%E8%AE%B0%E5%8D%95-V4.1.1.240422.xlsx",
        // 慢病毒包装订购表
        service: "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E6%85%A2%E7%97%85%E6%AF%92%E5%92%8C%E8%85%BA%E7%97%85%E6%AF%92%E5%8C%85%E8%A3%85%E4%BF%A1%E6%81%AF%E8%A1%A8V7.1.1.230818.xlsx",
      },
      // 基因合成-长单链订购表
      ssDNAOss:
        "https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E9%95%BF%E5%8D%95%E9%93%BEDNA%EF%BC%88ssDNA%EF%BC%89%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx",
    };
  },
  computed: {
    jumpsType() {
      switch (this.type) {
        case "gene":
        case "merging":
          return "gene";
        case "primer":
          return "primer";
        case "sanger":
          return "sanger";
      }
    },
    jumpFile() {
      return this.ossList[this.jumpsType]
    },
    downloadFile() {
      let type = this.downloadType ? this.downloadType : this.type
      switch (type) {
        case "gene-ssDNA" :
          return this.ssDNAOss;
        default :
          return this.ossList[type]
      }
    },
  },
  methods: {
    sangerDownloadFile(){
      let memberInfo = this.baseMethods.getLocalObj('memberInfo')
      sangerDownlodFile({customerId: memberInfo.id||'' }).then((res)=>{
         let link = document.createElement("a");
         let body = document.querySelector("body");
         link.href = window.URL.createObjectURL(res.data);
         link.download = "擎科生物测序样本登记表.xlsx";
         link.style.display = "none";
         body.appendChild(link);
         link.click();
         body.removeChild(link);
         window.URL.revokeObjectURL(link.href);
      })
    },
    jumps(path, name) {
      this.$router.push({ path, params: { name } });
      // 适应新需求，只需要footer中点击scrollTop为0
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and(max-width: 375px) and (min-width: 374px) {
  .phone {
    color: #fff;
  }
  .mt30 {
    margin-top: 0 !important;
  }
}
@media screen and (max-width: 640px) {
  .con {
    display: none !important;
  }
  .consult {
    margin-bottom: 0px !important;
  }
}
.consult {
  // margin-bottom: -130px;
  position: relative;
  z-index: 2;
  overflow: auto;
  .order {
    background: #f9f9f9 url("../assets/images/order_bg.png") no-repeat;
    li {
      border-bottom: 2px solid #fff;
      display: flex;
      align-items: center;
      padding: 20px 0;
      &:last-child {
        border: 0;
      }
      label {
        font-size: 20px;
        width: 200px;
        color: #fff;
        margin-right: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 8px;
        }
      }
      dl {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        dd {
          width: 33%;
          margin: 10px 0;
          white-space: nowrap;
        }
      }
      a {
        color: #333;
      }
      span {
        font-size: 16px;
        font-weight: bold;
        color: #014492;
        text-decoration: underline;
      }
    }
  }
  .order1 {
    background: #f9f9f9 url("../assets/img/产品及服务/virus.jpg") no-repeat;
    li {
      label {
        width: 260px;
        img {
          margin-left:10px;
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .container {
    width: 90% !important;
    font-size: 14px !important;
  }
  .wrap-tec .c-title {
    padding: 20px 0 20px !important;
    font-size: 20px !important;
  }
  .fb {
    line-height: 25px;
  }
  .consult .order li {
    display: block !important;
  }
  .consult .order li label {
    display: block !important;
    margin-left: 15px;
    text-align: center;
    font-size: 14px !important;
  }
  .consult .order li dl {
    display: block !important;
  }
  .consult .order li span {
    color: #fff;
    font-size: 12px !important;
  }
  .consult .order li dl dd {
    width: 90% !important;
    margin-left: auto;
    color: #fff;
    text-align: center;
    margin-right: auto;
  }
  .consult .order {
    background-size: 100% 100%;
  }
}
.order-form-box {
  font-size: 16px;
  text-align: center;
  a {
    font-weight: bold;
    font-size: 20px;
    color: #13489d;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewConsult.vue